import HttpClient from "../http/http_client";

export const getPointTableRequest = async () => {
    try {
        
        const response = await HttpClient.get('point-table/');
        return {
            success : true,
            data : response.data,
        }
    } catch (error) {
        if (error.response) {
            const {status, data} = error.response;
            return {
                success : false,
                status : status,
                errors : data?.errors || null,
            }
        }
    }
}